import { ContactRepFormState } from '../components/ContactRepModalView/Form';

const MessageTemplateNames = {
  pricingRequest: 'pricing_request',
  productLeadTime: 'product_lead_time',
  requestMeeting: 'request_meeting',
  installationImagery: 'installation_imagery',
};

export const getContactRepMessageTemplate = (
  props: ContactRepFormState,
): string[] => {
  const { other, message, representative, ...rest } = props;
  const selections: string[] = [];

  Object.entries(rest).forEach(([key, value]) => {
    if (value) {
      // @ts-expect-error // TODO: fix types
      selections.push(MessageTemplateNames[key]);
    }
  });

  return selections;
};
